import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import "@mantine/core/styles.css";

import "./App.css";

import "swiper/css";

import Layout from "./components/common/Layout";
import Home from "./pages/home";
import Transform from "./pages/transform";
import AdminLogin from "./pages/login";
import Dashboard from "./pages/admin";
import AContact from "./pages/admin/contact";
import AOneContact from "./pages/admin/contact/detail";
import AboutCompany from "./pages/about/company";
import AboutHistory from "./pages/about/history";
import AboutOrganization from "./pages/about/organization";
import ProductsFeatures from "./pages/products/features";
import ProductsLineUp from "./pages/products/lineup";
import AdminProduct from "./pages/admin/product";
import AdminProductDetail from "./pages/admin/product/detail";
import AdminCategory from "./pages/admin/category";
import AdminProductPost from "./pages/admin/product/post";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/transform" element={<Transform />} />
          <Route path="admin">
            <Route path="login" element={<AdminLogin />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="inquiry" element={<AContact />} />
            <Route path="inquiry/:id" element={<AOneContact />} />
            <Route path="category" element={<AdminCategory />} />
            <Route path="product" element={<AdminProduct />} />
            <Route path="product/:id" element={<AdminProductDetail />} />
            <Route path="product/new" element={<AdminProductPost />} />
          </Route>
          <Route path="about">
            <Route index element={<AboutCompany />} />
            <Route path="company" element={<AboutCompany />} />
            <Route path="history" element={<AboutHistory />} />
            <Route path="organization" element={<AboutOrganization />} />
          </Route>
          <Route path="products">
            <Route index element={<ProductsFeatures />} />
            <Route path="features" element={<ProductsFeatures />} />
            <Route path="line-up" element={<ProductsLineUp />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
